var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { MapControlsService } from 'app/services/map-controls.service';
import { MapSharedService } from 'app/services/map-shared.service';
import { FeatLayerControlComponent } from '../feat-layer-control/feat-layer-control.component';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { InterlayerMapService } from 'app/services/interlayer-map.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { LayerService } from 'app/services/layer.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { FeatMapBookmarkManagerComponent } from '../feat-map-bookmark-manager/feat-map-bookmark-manager.component';
var FeatMapControlsComponent = /** @class */ (function () {
    function FeatMapControlsComponent(activityService, attrIndexService, floatPopupService, layerService, mapControlsService, mapSharedService, mapLayerService, mapService, iMapService, 
    // private modalService: CommonModalService,
    reportService) {
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.floatPopupService = floatPopupService;
        this.layerService = layerService;
        this.mapControlsService = mapControlsService;
        this.mapSharedService = mapSharedService;
        this.mapLayerService = mapLayerService;
        this.mapService = mapService;
        this.iMapService = iMapService;
        this.reportService = reportService;
        this.mapType = 'data';
        this.showBasemapOpacitySlider = true;
        this.showZoomToRecord = false;
    }
    FeatMapControlsComponent.prototype.zoomToRecord = function () {
        if (!this.showZoomToRecord) {
            return;
        }
        this.mapControlsService.zoomToRecordSubject.next();
    };
    FeatMapControlsComponent.prototype.zoomIn = function () {
        var map = this.map;
        map.olMap.getView().setZoom(map.olMap.getView().getZoom() + 1);
    };
    FeatMapControlsComponent.prototype.zoomOut = function () {
        var map = this.map;
        var zoomLevel = map.olMap.getView().getZoom();
        if (zoomLevel > this.mapSharedService.minZoomLevel) {
            map.olMap.getView().setZoom(zoomLevel - 1);
        }
    };
    FeatMapControlsComponent.prototype.toggleLayerControl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dataLayerCateCode, refLayerCateCode, refReportLayerCateCode, layer, report, data, options;
            return __generator(this, function (_a) {
                if (this.mapType === 'data') {
                    layer = this.activityService.selectedLayerBS.getValue();
                    dataLayerCateCode = layer ? layer.layer.category.code : null;
                }
                else {
                    report = this.reportService.selectedReportBS.getValue();
                    dataLayerCateCode = report ? report.subjectLayerCate : null;
                    refLayerCateCode = report ? report.refLayerCate : null;
                    // TODO refReportLayerCateCode
                }
                data = {
                    mapType: this.mapType,
                    dataLayerCateCode: dataLayerCateCode,
                    refLayerCateCode: refLayerCateCode,
                    refReportLayerCateCode: refReportLayerCateCode
                };
                options = {
                    data: data
                };
                this.floatPopupService.openPopup(FeatLayerControlComponent, data, ['layer-control-popup']);
                return [2 /*return*/];
            });
        });
    };
    FeatMapControlsComponent.prototype.openBookmark = function () {
        this.floatPopupService.openPopup(FeatMapBookmarkManagerComponent, null, ['map-bookmark-popup']);
    };
    FeatMapControlsComponent.prototype.onRefSliderDragEnd = function () {
        var layer = this.iMapService.map.addedLayers[this.iMapService.secondDataLayerName];
        this.mapSharedService.updateLayerOpacity(layer, this.refLayerOpacity);
    };
    FeatMapControlsComponent.prototype.onBasemapSliderDragEnd = function () {
        var map = this.map;
        this.mapSharedService.updateLayerOpacity(map.baseMapLayerGroup, this.basemapOpacity);
    };
    FeatMapControlsComponent.prototype.onMouseoverMapLegend = function () {
        var _this = this;
        if (this.mapLegendTimeout) {
            clearTimeout(this.mapLegendTimeout);
        }
        this.mapLegendTimeout = setTimeout(function () {
            _this.mapService.mapLegendBS.next({
                show: true
            });
            _this.mapLegendTimeout = null;
        }, 200);
    };
    FeatMapControlsComponent.prototype.onMouseoutMapLegend = function () {
        var _this = this;
        if (this.mapLegendTimeout) {
            clearTimeout(this.mapLegendTimeout);
        }
        this.mapLegendTimeout = setTimeout(function () {
            _this.mapService.mapLegendBS.next({
                show: false
            });
            _this.mapLegendTimeout = null;
        }, 1500);
    };
    FeatMapControlsComponent.prototype.setDataMapConfigs = function () {
        var _this = this;
        this.mapSub = this.mapService.mapBS.subscribe(function (data) { return _this.map = data; });
        this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(function (l) {
            var map = _this.map;
            if (!map) {
                return;
            }
            // this.setBdryLayers();
        });
        this.currentCardSub = this.activityService.currentCardBS.subscribe(function (data) {
            if (data && data.id) {
                _this.showZoomToRecord = true;
            }
            else {
                _this.showZoomToRecord = false;
            }
        });
    };
    FeatMapControlsComponent.prototype.setReportMapConfigs = function () {
        var _this = this;
        this.refLayerOpacity = this.iMapService.initRefLayerOpacity;
        this.mapSub = this.mapService.mapBS.subscribe(function (data) { return _this.map = data; });
        this.selectedRecordSub = this.reportService.selectedReportRecordsBS.subscribe(function (data) {
            if (data && data.rec) {
                _this.showZoomToRecord = true;
            }
            else {
                _this.showZoomToRecord = false;
            }
        });
    };
    FeatMapControlsComponent.prototype.ngOnInit = function () {
        this.showRefLayerOpacitySlider = this.mapType === 'report';
        this.basemapOpacity = this.mapSharedService.initBasemapOpacity;
    };
    FeatMapControlsComponent.prototype.ngAfterViewInit = function () {
        switch (this.mapType) {
            case 'data':
                this.setDataMapConfigs();
                break;
            case 'report':
                this.setReportMapConfigs();
                break;
        }
    };
    FeatMapControlsComponent.prototype.ngOnDestroy = function () {
        this.mapSub.unsubscribe();
        if (this.mapType === 'data') {
            this.currentCardSub.unsubscribe();
            this.selectedLayerSub.unsubscribe();
        }
        else if (this.mapType === 'report') {
            this.selectedRecordSub.unsubscribe();
        }
    };
    return FeatMapControlsComponent;
}());
export { FeatMapControlsComponent };
